<template>
  <div class="contact-us-page">
    <ul class="seo_top">
      <li
        v-for="item in list"
        :key="item.uid"
        :class="item.uid === currentId ? 'active' : ''"
        @click="get_honor(item.uid)"
      >
        <a href="javascript:;">{{ item.name }}</a>
      </li>
    </ul>
    <div
      class="container-wrapper"
      :style="{ height: addStepDiffHeight }"
      ref="containerWrapper"
    >
      <div class="container-step" ref="containerStep">
        <div
          class="item-step"
          v-for="(item, index) in info"
          :key="item.id"
          :class="index % 2 !== 0 ? 'cont_right' : 'cont_left'"
          :style="itemStepStyle(item, index)"
        >
          <div class="step__head">
            <div class="step__line">
              <i class="step__line-inner"></i>
            </div>
            <div class="step__icon">
              <img
                :class="index % 2 !== 0 ? 'two' : 'one'"
                src="@assets/images/zxq@2x.png"
                alt
              />
            </div>
          </div>
          <div class="step__main">
            <div class="step__title">
              <h3>{{ item.name }}</h3>
              <p>{{ item.time }}</p>
            </div>
            <div class="step__description">
              <van-image
                :width="vanImageW"
                :height="vanImageW / 2 + vanImageW"
                :src="item.image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hiden"></div>
  </div>
</template>

<script>
import { getHonorData } from "@api/common";
import { getHonorDatain } from "@api/common";

export default {
  data() {
    return {
      vanImageW: document.body.offsetWidth / 2 - 24,
      addStepDiffHeight: "0", // 容器总高度
      stepItemDiffTop: 120, // 每个子元素距离顶部差值
      list: [],
      currentId: 1,
      info: []
    };
  },
  created() {
    this.getDataInfo();
    this.get_honor(1); //默认进入第一项
  },
  methods: {
    // 获取整体数据
    getDataInfo() {
      getHonorData().then(res => {
        console.log(res);
        if (res.status === 200) {
          this.list = res.data;
          console.log(this.list);
        }
      });
    },
    get_honor(id) {
      this.currentId = id;
      getHonorDatain({ uid: id }).then(res => {
        console.log(res);
        this.info = res.data;
        this.$nextTick(() => {
          this.handleComputedHeight();
        });
      });
    },
    handleComputedHeight() {
      let contEl = this.$refs.containerStep;
      let wrapEl = this.$refs.containerWrapper;
      let len = this.info.length;
      if (contEl && wrapEl && len) {
        wrapEl.style.height = "1000%";
        setTimeout(() => {
          let contElHeight = contEl.offsetHeight;
          let wH = contElHeight - len * this.stepItemDiffTop;
          wrapEl.style.height = wH + 50 + "px";
        }, 300);
      }
    }
  },
  computed: {
    itemStepStyle() {
      const vm = this;
      return (info, index) => {
        let top = 0;
        if (index !== 0) {
          top = index * vm.stepItemDiffTop;
        }
        return {
          top: `-${top}px`
        };
      };
    }
  }
};
</script>

<style scoped lang="scss">
div,
ul,
li {
  box-sizing: border-box;
}
.contact-us-page {
  // height: 100%;
  background-color: rgba($color: #fff, $alpha: 1);
  .seo_top {
    border-bottom: 1px solid #d8d8d8;
    width: 100%;
    height: 45px;
    li {
      float: left;
      text-align: center;
      width: 45%;
      height: 45px;
      line-height: 45px;
      box-shadow: 0 3px 5px 0 rgba(76, 133, 255, 0.5);
      border-radius: 1px;
      margin-left: 13px;
      a {
        color: #4c84ff;
        font-size: 12px;
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
.active {
  border-bottom: 3px solid #11aaff;
}
$width-step-head: 24px;
.container-wrapper {
  overflow: hidden;
}
.container-step {
  width: 50%;
  position: relative;
  left: 50%;
  flex-flow: column;
  padding: 1rem 0;

  .item-step {
    display: flex;
    position: relative;
    flex-shrink: 1;
    padding-left: $width-step-head;
    left: -12px;

    .step__head {
      flex-grow: 0;
      width: $width-step-head;
      color: #409eff;
      border-color: #409eff;
      position: absolute;
      left: 0;
      height: 100%;

      .step__line {
        margin-right: 0px;
        width: 2px;
        top: 0;
        bottom: 0;
        left: 11px;
        position: absolute;
        border-color: inherit;
        background-color: #4c84ff;
      }

      .step__icon {
        position: relative;
        z-index: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        background: #fff;
        transition: 0.15s ease-out;

        img {
          width: 100%;
          height: auto;
          margin-left: -4px;
          &.two {
            transform: rotate(180deg);
            margin-left: 4px;
          }
        }
      }
    }

    .step__main {
      padding-left: 10px;
      flex-grow: 1;
      white-space: normal;
      text-align: left;

      .step__title {
        line-height: 24px;
        padding-bottom: 8px;
        font-size: 16px;
        h3 {
          font-weight: bold;
          padding-right: 13%;
        }
        p {
          color: #666666;
          padding-right: 13%;
        }
      }
      .step__description {
        // width: 300px;
        padding-right: 10%;
        margin-top: -5px;
        font-size: 12px;
        line-height: 20px;
        font-weight: 400;
        img {
          width: 100%;
        }
      }
    }

    &.cont_left {
      transform: translateX(calc(-100% - -24px));
      padding-left: 0;
      padding-right: $width-step-head;
      text-align: right;
      right: -12px;
      .step__head {
        left: auto;
        right: 0;
      }
      .step__main {
        .step__title {
          text-align: right;
        }
      }
    }
  }
}
</style>
